import { gql } from "@apollo/client";

export const PROCESS_PUBLIC_TOKEN = gql`
  mutation processPublicToken($institutionId: String!, $publicToken: String!) {
    processPublicToken(
      input: { institutionId: $institutionId, publicToken: $publicToken }
    )
  }
`;

export const LOGIN_USER = gql`
  mutation loginUser($email: String!, $password: String!) {
    loginUser(input: { email: $email, password: $password }) {
      token
    }
  }
`;

export const REGISTER_USER = gql`
  mutation registerUser(
    $email: String!
    $password: String!
    $promotionCode: String
  ) {
    registerUser(
      input: {
        email: $email
        password: $password
        promotionCode: $promotionCode
      }
    ) {
      token
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation resetPassword($email: String, $password: String, $token: String) {
    resetPassword(input: { email: $email, password: $password, token: $token })
  }
`;
